import { render, staticRenderFns } from "./marketplaceTags.vue?vue&type=template&id=830dff94&scoped=true&"
import script from "./marketplaceTags.vue?vue&type=script&lang=js&"
export * from "./marketplaceTags.vue?vue&type=script&lang=js&"
import style0 from "./marketplaceTags.vue?vue&type=style&index=0&id=830dff94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830dff94",
  null
  
)

export default component.exports